




import { AuthService } from "@/common/api";
import Vue from "vue";
import Component from "vue-class-component";
import { namespace } from "vuex-class";
import defineAbilityFor from "@/services/ability";

const auth = namespace("MemberAuth");

@Component({
  name: "CallbackLine",
  components: {},
  directives: {},
})
export default class CallbackLine extends Vue {
  @auth.Getter
  userLogging: any;
  @auth.Action
  updateToken!: (token: string) => void;
  @auth.Action
  updateExpiredAt!: (time: string) => void;
  @auth.Action
  updateRole!: (role: string) => void;
  @auth.Action
  setUser!: (user) => void;
  @auth.Action
  fetchCurrentUser!: () => void;

  loginLineUrl = "";

  private form = {
    email: "",
    password: "",
  };
  private errorMessage = "";
  errors = {};

  public created() {
    console.log("OK");
  }

  public async mounted() {
    const response = await AuthService.lineLoginCallback({
      code: this.$route.query.code.toString(),
    });

    if (response.data.token) {
      // Save it to state
      this.updateToken(response.data.token);
      await this.fetchCurrentUser();

      // Set ability
      this.$ability.update(defineAbilityFor("member").rules);

      this.$router.push({ name: "mypage" });
    } else {
      localStorage.setItem("line_account_id", response.data?.line_account_id);
      this.$router.push({
        name: "login",
      });
    }

    console.log(response);
  }
}
